// app/frontend/js/controllers/set_list_entries_controller.js
import { Controller } from "@hotwired/stimulus";
import { showErrorFlash } from "../lib/flash.js";

export default class extends Controller {
  static targets = ["count", "destination", "form", "source"];
  static values = {
    setlistId: String,
  };

  connect() {
    this.isProcessing = false;
  }

  addOrRemoveSong(event) {
    event.preventDefault();
    if (this.isProcessing) return;
    this.isProcessing = true;

    const songIds = Array.from(
      this.destinationTarget.querySelectorAll("li")
    ).map((li) => {
      return li.dataset.id;
    });
    const row = event.target.closest("li");
    const songId = row.dataset.id;
    if (!songIds.includes(songId)) {
      songIds.push(songId);
    } else {
      // If the song ID is already in the array, remove it
      row.classList.add("bg-blue-100", "dark:bg-blue-950/40");
      songIds.splice(songIds.indexOf(songId), 1);
    }

    fetch(this.formTarget.action, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/html", // Request HTML
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
      body: JSON.stringify({
        set_list: {
          song_ids: songIds,
        },
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Server responded with ${response.status}`);
        }
        return response.text();
      })
      .then((html) => {
        // Create a temporary container to parse the HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // Find the destination div in the returned HTML
        const newDestination = doc.querySelector(
          '[data-set-list-entries-target="destination"]'
        );

        if (newDestination) {
          // Replace just the contents of the destination div
          this.destinationTarget.innerHTML = newDestination.innerHTML;
        } else {
          // console.error(
          //   "Could not find destination element in the returned HTML"
          // );
        }

        row.classList.remove("bg-blue-100", "dark:bg-blue-950/40");
        this.sourceTarget
          .querySelector(`#song_${songId}`)
          ?.classList.toggle("selected", songIds.includes(songId));
        if (this.hasCountTarget) {
          this.countTarget.textContent = `${songIds.length} ${
            songIds.length === 1 ? "song" : "songs"
          }`;
        }
      })
      .catch(() => {
        row.classList.remove("bg-blue-100", "dark:bg-blue-950/40");
        showErrorFlash("The set list could not be updated. Please try again.");
      })
      .finally(() => {
        // After a delay, allow processing again
        setTimeout(() => {
          this.isProcessing = false;
        }, 300);
      });
  }
}
